import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ReportedListing_Create, ReportedListing_ReadAll, ReportedListing_ReadByBusinessId, ReportedListing_ReadById, ReportedListing_ReadByMasterId, ReportedListing_Update } from "src/app/GlobalVariable";
import { ReportedListingCreateRequestDTO, ReportedListingDTO, ReportedListingList, ReportedListingReadByBusinessId, ReportedListingReadById, ReportedListingReadByMasterId, ReportedListingUpdateRequestDTO } from "./reportedListing.interface";

@Injectable({
    providedIn: 'root'
})

export class ReportedListingService {
    private http = inject(HttpClient);

    ReportedListing_Create(data: ReportedListingCreateRequestDTO): Observable<ReportedListingDTO> {
        return this.http.post<ReportedListingDTO>(ReportedListing_Create, data);
    }

    ReportedListing_Update(data: ReportedListingUpdateRequestDTO): Observable<ReportedListingDTO> {
        return this.http.post<ReportedListingDTO>(ReportedListing_Update, data);
    }

    ReportedListing_ReadAll(): Observable<ReportedListingList> {
        return this.http.get<ReportedListingList>(ReportedListing_ReadAll);
    }

    ReportedListing_ReadById(data: ReportedListingReadById): Observable<ReportedListingDTO> {
        return this.http.post<ReportedListingDTO>(ReportedListing_ReadById, data);
    }

    ReportedListing_ReadByMasterId(data: ReportedListingReadByMasterId): Observable<ReportedListingList> {
        return this.http.post<ReportedListingList>(ReportedListing_ReadByMasterId, data);
    }

    ReportedListing_ReadByBusinessId(data: ReportedListingReadByBusinessId): Observable<ReportedListingList> {
        return this.http.post<ReportedListingList>(ReportedListing_ReadByBusinessId, data);
    }
}